import { WIDGET_FORM_INPUT_ICON } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const IconInputWidget: WidgetRegistryEntry = {
  name: WIDGET_FORM_INPUT_ICON,
  component: () => import("./icon-input-widget.component").then((m) => m.IconInputWidgetComponent)
};
